import Vue from 'vue'
import appService from '../../server/app.service'
import _ from 'lodash'
import router from '../../router'

import { getField, updateField } from 'vuex-map-fields';

const state = {
    settings:[],
    scripts:[],
    scriptTypes:[],
    id: 0
}

const getters = {
    settings: state => state.settings,
    scripts: state => state.scripts,
    scriptTypes: state => state.scriptTypes,
    getField
}

const actions = {

    loadSettings (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            context.commit('loadSettings', { result: data })
        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', this.error)
        })
    },

    saveSettings (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            if( data.success ) {
                this.dispatch('addMessage', data)
            } else {
                this.dispatch('addMessage', data)
            }
        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', this.error)

        })
    },

    addScript(context) {
        context.commit('addScript')
    },

    deleteScript(context, id) {
        context.commit('deleteScript', id)
    }

}

const mutations = {
    loadSettings (state, data) {
        state.settings = data.result.data.Settings
        state.scripts = data.result.data.Scripts
        state.scriptTypes = data.result.data.ScriptType
    },
    addScript (state) {
        state.scripts.push({ platform: '1', type_id: '1', script: '', id: '', deleted: false });
    },
    deleteScript(context, id) {
        state.scripts[id].deleted = true;
    },
    updateField,
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
